/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SourceForm from "./SourceForm";
import { createSource } from "./sourceSlice";

export default function CreateSourceContainer() {
    const breadcrumbItems = [
        { label: 'Home', href: '/admin/home', isActive: false },
        { label: 'Sources', href: '/admin/sources', isActive: false },
        { label: 'Create Source', href: '', isActive: true }
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const sourceState = useSelector(state => state.source);

    const handleCancel = () => {
        navigate('/admin/sources');
    };

    const handleSave = (data) => {
        dispatch(createSource(data));
    };

    return (
        <SourceForm
            mode="create"
            initialData={null}
            onSave={handleSave}
            onCancel={handleCancel}
            breadcrumbItems={breadcrumbItems}
            loading={sourceState.loading}
            alertMessage={{text: sourceState.alertMessage, id: Date.now()}}
            successMessage={{text: sourceState.successMessage, id: Date.now()}}
        />
    );
}
